import React from "react";
import { useSelector } from "react-redux";
import { Modal, ModalHeader } from "reactstrap";
import closeIcon from "../../../assets/images/bingo/cross-icon.png";
import _ from "lodash";

function HowToPlay({ set_how_to_play }) {
  const gameParams = useSelector((state) => state.paramsReducer.gameObj);
  const how_label = _.get(gameParams, "1_joining.how_label", "HOW TO PLAY");
  const how_text = _.get(gameParams, "1_joining.how_text");
  return (
    <Modal
      isOpen={true}
      centered={true}
      backdrop={true}
      className="bingo-how-to-play-modal"
      contentClassName="bingo-how-to-play-modal-content"
      backdropClassName="bingo-how-to-play-modal-backdrop"
      scrollable={true}
    >
      <ModalHeader
        close={
          <img
            src={closeIcon}
            alt="close"
            className="close"
            onClick={() => {
              set_how_to_play(false);
            }}
          />
        }
      >
        {how_label}
      </ModalHeader>
      <div className="modal-body">{how_text && how_text.map((item) => <p className="desc">{item}</p>)}</div>
    </Modal>
  );
}

export default HowToPlay;
